var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createStore } from "mipd";
import { EVENTS_API_URL, EventType, LOCAL_ANONYMOUS_ID_KEY, SESSION_CURRENT_URL_KEY, SESSION_USER_ID_KEY, SESSION_WALLET_DETECTED_KEY, } from "./constants";
import { EventManager, EventQueue, local, logger, Logger, session, } from "./lib";
import { SignatureStatus, TransactionStatus, } from "./types";
import { isAddress, isLocalhost } from "./validators";
var FormoAnalytics = /** @class */ (function () {
    function FormoAnalytics(writeKey, options) {
        if (options === void 0) { options = {}; }
        var _a, _b;
        this.writeKey = writeKey;
        this.options = options;
        this._providerListeners = {};
        this.config = {
            writeKey: writeKey,
            trackLocalhost: options.trackLocalhost || false,
        };
        this.session = new FormoAnalyticsSession();
        this.currentUserId =
            session.get(SESSION_USER_ID_KEY) || undefined;
        // Initialize logger with configuration from options
        Logger.init({
            enabled: ((_a = options.logger) === null || _a === void 0 ? void 0 : _a.enabled) || false,
            enabledLevels: ((_b = options.logger) === null || _b === void 0 ? void 0 : _b.levels) || [],
        });
        this.eventManager = new EventManager(new EventQueue(this.config.writeKey, {
            url: EVENTS_API_URL,
            flushAt: options.flushAt,
            retryCount: options.retryCount,
            maxQueueSize: options.maxQueueSize,
            flushInterval: options.flushInterval,
        }));
        // TODO: replace with eip6963
        var provider = options.provider || (window === null || window === void 0 ? void 0 : window.ethereum);
        if (provider) {
            this.trackProvider(provider);
        }
        this.trackFirstPageHit();
        this.trackPageHits();
    }
    FormoAnalytics.init = function (writeKey, options) {
        return __awaiter(this, void 0, void 0, function () {
            var analytics, providers;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        analytics = new FormoAnalytics(writeKey, options);
                        return [4 /*yield*/, analytics.getProviders()];
                    case 1:
                        providers = _a.sent();
                        return [4 /*yield*/, analytics.detectWallets(providers)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, analytics];
                }
            });
        });
    };
    /*
      Public SDK functions
    */
    /**
     * Emits a page visit event with the current URL information, fire on page change.
     * @param {string} category - The category of the page
     * @param {string} name - The name of the page
     * @param {Record<string, any>} properties - Additional properties to include
     * @param {Record<string, any>} context - Additional context to include
     * @returns {Promise<void>}
     */
    FormoAnalytics.prototype.page = function (category, name, properties, context) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.trackPageHit(category, name, properties, context)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Reset the current user session.
     * @returns {void}
     */
    FormoAnalytics.prototype.reset = function () {
        this.currentUserId = undefined;
        local.remove(LOCAL_ANONYMOUS_ID_KEY);
        session.remove(SESSION_USER_ID_KEY);
    };
    /**
     * Emits a connect wallet event.
     * @param {ChainID} params.chainId
     * @param {Address} params.address
     * @param {IFormoEventProperties} properties
     * @param {IFormoEventContext} context
     * @param {(...args: unknown[]) => void} callback
     * @throws {Error} If chainId or address is empty
     * @returns {Promise<void>}
     */
    FormoAnalytics.prototype.connect = function (_a, properties_1, context_1, callback_1) {
        return __awaiter(this, arguments, void 0, function (_b, properties, context, callback) {
            var chainId = _b.chainId, address = _b.address;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!chainId) {
                            logger.warn("Connect: Chain ID cannot be empty");
                        }
                        if (!address) {
                            logger.warn("Connect: Address cannot be empty");
                        }
                        this.currentChainId = chainId;
                        this.currentAddress = address;
                        return [4 /*yield*/, this.trackEvent(EventType.CONNECT, {
                                chainId: chainId,
                                address: address,
                            }, properties, context, callback)];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emits a wallet disconnect event.
     * @param {ChainID} params.chainId
     * @param {Address} params.address
     * @param {IFormoEventProperties} properties
     * @param {IFormoEventContext} context
     * @param {(...args: unknown[]) => void} callback
     * @returns {Promise<void>}
     */
    FormoAnalytics.prototype.disconnect = function (params, properties, context, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var address, chainId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        address = (params === null || params === void 0 ? void 0 : params.address) || this.currentAddress;
                        chainId = (params === null || params === void 0 ? void 0 : params.chainId) || this.currentChainId;
                        return [4 /*yield*/, this.handleDisconnect(chainId, address, properties, context, callback)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emits a chain network change event.
     * @param {ChainID} params.chainId
     * @param {Address} params.address
     * @param {IFormoEventProperties} properties
     * @param {IFormoEventContext} context
     * @param {(...args: unknown[]) => void} callback
     * @throws {Error} If chainId is empty, zero, or not a valid number
     * @throws {Error} If no address is provided and no previous address is recorded
     * @returns {Promise<void>}
     */
    FormoAnalytics.prototype.chain = function (_a, properties_1, context_1, callback_1) {
        return __awaiter(this, arguments, void 0, function (_b, properties, context, callback) {
            var chainId = _b.chainId, address = _b.address;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!chainId || Number(chainId) === 0) {
                            throw new Error("FormoAnalytics::chain: chainId cannot be empty or 0");
                        }
                        if (isNaN(Number(chainId))) {
                            throw new Error("FormoAnalytics::chain: chainId must be a valid decimal number");
                        }
                        if (!address && !this.currentAddress) {
                            throw new Error("FormoAnalytics::chain: address was empty and no previous address has been recorded");
                        }
                        this.currentChainId = chainId;
                        return [4 /*yield*/, this.trackEvent(EventType.CHAIN, {
                                chainId: chainId,
                                address: address || this.currentAddress,
                            }, properties, context, callback)];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emits a signature event.
     * @param {SignatureStatus} params.status - requested, confirmed, rejected
     * @param {ChainID} params.chainId
     * @param {Address} params.address
     * @param {string} params.message
     * @param {string} params.signatureHash - only provided if status is confirmed
     * @param {IFormoEventProperties} properties
     * @param {IFormoEventContext} context
     * @param {(...args: unknown[]) => void} callback
     * @returns {Promise<void>}
     */
    FormoAnalytics.prototype.signature = function (_a, properties_1, context_1, callback_1) {
        return __awaiter(this, arguments, void 0, function (_b, properties, context, callback) {
            var status = _b.status, chainId = _b.chainId, address = _b.address, message = _b.message, signatureHash = _b.signatureHash;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.trackEvent(EventType.SIGNATURE, __assign({ status: status, chainId: chainId, address: address, message: message }, (signatureHash && { signatureHash: signatureHash })), properties, context, callback)];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emits a transaction event.
     * @param {TransactionStatus} params.status - started, broadcasted, rejected
     * @param {ChainID} params.chainId
     * @param {Address} params.address
     * @param {string} params.data
     * @param {string} params.to
     * @param {string} params.value
     * @param {string} params.transactionHash - only provided if status is broadcasted
     * @param {IFormoEventProperties} properties
     * @param {IFormoEventContext} context
     * @param {(...args: unknown[]) => void} callback
     * @returns {Promise<void>}
     */
    FormoAnalytics.prototype.transaction = function (_a, properties_1, context_1, callback_1) {
        return __awaiter(this, arguments, void 0, function (_b, properties, context, callback) {
            var status = _b.status, chainId = _b.chainId, address = _b.address, data = _b.data, to = _b.to, value = _b.value, transactionHash = _b.transactionHash;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.trackEvent(EventType.TRANSACTION, __assign({ status: status, chainId: chainId, address: address, data: data, to: to, value: value }, (transactionHash && { transactionHash: transactionHash })), properties, context, callback)];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emits an identify event with current wallet address and provider info.
     * @param {string} params.providerName
     * @param {string} params.rdns
     * @param {string} params.userId
     * @param {string} params.address
     * @param {IFormoEventProperties} properties
     * @param {IFormoEventContext} context
     * @param {(...args: unknown[]) => void} callback
     * @returns {Promise<void>}
     */
    FormoAnalytics.prototype.identify = function (params, properties, context, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var userId, address, providerName, rdns;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        userId = params.userId, address = params.address, providerName = params.providerName, rdns = params.rdns;
                        this.currentAddress = address;
                        if (userId) {
                            this.currentUserId = userId;
                            session.set(SESSION_USER_ID_KEY, userId);
                        }
                        return [4 /*yield*/, this.trackEvent(EventType.IDENTIFY, {
                                address: address,
                                providerName: providerName,
                                userId: userId,
                                rdns: rdns,
                            }, properties, context, callback)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emits a detect wallet event with current wallet provider info.
     * @param {string} params.providerName
     * @param {string} params.rdns
     * @param {IFormoEventProperties} properties
     * @param {IFormoEventContext} context
     * @param {(...args: unknown[]) => void} callback
     * @returns {Promise<void>}
     */
    FormoAnalytics.prototype.detect = function (_a, properties_1, context_1, callback_1) {
        return __awaiter(this, arguments, void 0, function (_b, properties, context, callback) {
            var providerName = _b.providerName, rdns = _b.rdns;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (this.session.isWalletDetected(rdns))
                            return [2 /*return*/, logger.warn("Detect: Wallet ".concat(providerName, " already detected in this session"))];
                        this.session.markWalletDetected(rdns);
                        return [4 /*yield*/, this.trackEvent(EventType.DETECT, {
                                providerName: providerName,
                                rdns: rdns,
                            }, properties, context, callback)];
                    case 1:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emits a custom user event with custom properties.
     * @param {string} event The name of the tracked event
     * @param {IFormoEventProperties} properties
     * @param {IFormoEventContext} context
     * @param {(...args: unknown[]) => void} callback
     * @returns {Promise<void>}
     */
    FormoAnalytics.prototype.track = function (event, properties, context, callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.trackEvent(EventType.TRACK, { event: event }, properties, context, callback)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /*
      SDK tracking and event listener functions
    */
    FormoAnalytics.prototype.trackProvider = function (provider) {
        try {
            if (provider === this._provider) {
                logger.warn("TrackProvider: Provider already tracked.");
                return;
            }
            this.currentChainId = undefined;
            this.currentAddress = undefined;
            if (this._provider) {
                var actions = Object.keys(this._providerListeners);
                for (var _i = 0, actions_1 = actions; _i < actions_1.length; _i++) {
                    var action = actions_1[_i];
                    this._provider.removeListener(action, this._providerListeners[action]);
                    delete this._providerListeners[action];
                }
            }
            this._provider = provider;
            // Register listeners for web3 provider events
            this.registerAddressChangedListener();
            this.registerChainChangedListener();
            this.registerSignatureListener();
            this.registerTransactionListener();
        }
        catch (error) {
            logger.error("Error tracking provider:", error);
        }
    };
    FormoAnalytics.prototype.registerAddressChangedListener = function () {
        var _this = this;
        var _a, _b;
        var listener = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.onAddressChanged(args[0]);
        };
        (_a = this._provider) === null || _a === void 0 ? void 0 : _a.on("accountsChanged", listener);
        this._providerListeners["accountsChanged"] = listener;
        var onAddressDisconnected = this.onAddressDisconnected.bind(this);
        (_b = this._provider) === null || _b === void 0 ? void 0 : _b.on("disconnect", onAddressDisconnected);
        this._providerListeners["disconnect"] = onAddressDisconnected;
    };
    FormoAnalytics.prototype.registerChainChangedListener = function () {
        var _this = this;
        var _a;
        var listener = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.onChainChanged(args[0]);
        };
        (_a = this.provider) === null || _a === void 0 ? void 0 : _a.on("chainChanged", listener);
        this._providerListeners["chainChanged"] = listener;
    };
    FormoAnalytics.prototype.registerSignatureListener = function () {
        var _this = this;
        var _a;
        if (!this.provider) {
            logger.error("Provider not found for signature tracking");
            return;
        }
        if (((_a = Object.getOwnPropertyDescriptor(this.provider, "request")) === null || _a === void 0 ? void 0 : _a.writable) ===
            false) {
            logger.warn("Provider.request is not writable");
            return;
        }
        var request = this.provider.request.bind(this.provider);
        this.provider.request = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var response, error_1, rpcError;
            var method = _b.method, params = _b.params;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(Array.isArray(params) &&
                            ["eth_signTypedData_v4", "personal_sign"].includes(method))) return [3 /*break*/, 4];
                        // Emit signature request event
                        this.signature(__assign({ status: SignatureStatus.REQUESTED }, this.buildSignatureEventPayload(method, params)));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, request({ method: method, params: params })];
                    case 2:
                        response = (_c.sent());
                        if (response) {
                            // Emit signature confirmed event
                            this.signature(__assign({ status: SignatureStatus.CONFIRMED }, this.buildSignatureEventPayload(method, params, response)));
                        }
                        return [2 /*return*/, response];
                    case 3:
                        error_1 = _c.sent();
                        rpcError = error_1;
                        if (rpcError && (rpcError === null || rpcError === void 0 ? void 0 : rpcError.code) === 4001) {
                            // Emit signature rejected event
                            this.signature(__assign({ status: SignatureStatus.REJECTED }, this.buildSignatureEventPayload(method, params)));
                        }
                        throw error_1;
                    case 4: return [2 /*return*/, request({ method: method, params: params })];
                }
            });
        }); };
        return;
    };
    FormoAnalytics.prototype.registerTransactionListener = function () {
        var _this = this;
        var _a;
        if (!this.provider) {
            logger.error("Provider not found for transaction tracking");
            return;
        }
        if (((_a = Object.getOwnPropertyDescriptor(this.provider, "request")) === null || _a === void 0 ? void 0 : _a.writable) ===
            false) {
            logger.warn("Provider.request is not writable");
            return;
        }
        var request = this.provider.request.bind(this.provider);
        this.provider.request = function (_a) { return __awaiter(_this, [_a], void 0, function (_b) {
            var payload, transactionHash, error_2, rpcError;
            var method = _b.method, params = _b.params;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(Array.isArray(params) &&
                            method === "eth_sendTransaction" &&
                            params[0])) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.buildTransactionEventPayload(params)];
                    case 1:
                        payload = _c.sent();
                        this.transaction(__assign({ status: TransactionStatus.STARTED }, payload));
                        _c.label = 2;
                    case 2:
                        _c.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, request({ method: method, params: params })];
                    case 3:
                        transactionHash = (_c.sent());
                        // Track transaction broadcast
                        this.transaction(__assign(__assign({ status: TransactionStatus.BROADCASTED }, payload), { transactionHash: transactionHash }));
                        return [2 /*return*/];
                    case 4:
                        error_2 = _c.sent();
                        logger.error("Transaction error:", error_2);
                        rpcError = error_2;
                        if (rpcError && (rpcError === null || rpcError === void 0 ? void 0 : rpcError.code) === 4001) {
                            // Emit transaction rejected event
                            this.transaction(__assign({ status: TransactionStatus.REJECTED }, payload));
                        }
                        throw error_2;
                    case 5: return [2 /*return*/, request({ method: method, params: params })];
                }
            });
        }); };
        return;
    };
    FormoAnalytics.prototype.onAddressChanged = function (addresses) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (addresses.length > 0) {
                    this.onAddressConnected(addresses[0]);
                }
                else {
                    this.onAddressDisconnected();
                }
                return [2 /*return*/];
            });
        });
    };
    FormoAnalytics.prototype.onAddressConnected = function (address) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (address === this.currentAddress)
                            // We have already reported this address
                            return [2 /*return*/];
                        this.currentAddress = address;
                        _a = this;
                        return [4 /*yield*/, this.getCurrentChainId()];
                    case 1:
                        _a.currentChainId = _b.sent();
                        this.connect({ chainId: this.currentChainId, address: address });
                        return [2 /*return*/];
                }
            });
        });
    };
    FormoAnalytics.prototype.handleDisconnect = function (chainId, address, properties, context, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var payload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            chainId: chainId || this.currentChainId,
                            address: address || this.currentAddress,
                        };
                        this.currentChainId = undefined;
                        this.currentAddress = undefined;
                        session.remove(SESSION_USER_ID_KEY);
                        return [4 /*yield*/, this.trackEvent(EventType.DISCONNECT, payload, properties, context, callback)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FormoAnalytics.prototype.onAddressDisconnected = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.handleDisconnect(this.currentChainId, this.currentAddress)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    FormoAnalytics.prototype.onChainChanged = function (chainIdHex) {
        return __awaiter(this, void 0, void 0, function () {
            var address;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.currentChainId = parseInt(chainIdHex);
                        if (!!this.currentAddress) return [3 /*break*/, 2];
                        if (!this.provider) {
                            logger.info("OnChainChanged: Provider not found. CHAIN_CHANGED not reported");
                            return [2 /*return*/, Promise.resolve()];
                        }
                        return [4 /*yield*/, this.getAddress()];
                    case 1:
                        address = _a.sent();
                        if (!address) {
                            logger.info("OnChainChanged: Unable to fetch or store connected address");
                            return [2 /*return*/, Promise.resolve()];
                        }
                        this.currentAddress = address;
                        _a.label = 2;
                    case 2:
                        // Proceed only if the address exists
                        if (this.currentAddress) {
                            return [2 /*return*/, this.chain({
                                    chainId: this.currentChainId,
                                    address: this.currentAddress,
                                })];
                        }
                        else {
                            logger.info("OnChainChanged: Current connected address is null despite fetch attempt");
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FormoAnalytics.prototype.trackFirstPageHit = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (session.get(SESSION_CURRENT_URL_KEY) === null) {
                    session.set(SESSION_CURRENT_URL_KEY, window.location.href);
                }
                return [2 /*return*/, this.trackPageHit()];
            });
        });
    };
    FormoAnalytics.prototype.trackPageHits = function () {
        return __awaiter(this, void 0, void 0, function () {
            var oldPushState, oldReplaceState;
            var _this = this;
            return __generator(this, function (_a) {
                oldPushState = history.pushState;
                history.pushState = function pushState() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var ret = oldPushState.apply(this, args);
                    window.dispatchEvent(new window.Event("locationchange"));
                    return ret;
                };
                oldReplaceState = history.replaceState;
                history.replaceState = function replaceState() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var ret = oldReplaceState.apply(this, args);
                    window.dispatchEvent(new window.Event("locationchange"));
                    return ret;
                };
                window.addEventListener("popstate", function () { return _this.onLocationChange(); });
                window.addEventListener("locationchange", function () { return _this.onLocationChange(); });
                return [2 /*return*/];
            });
        });
    };
    FormoAnalytics.prototype.onLocationChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentUrl;
            return __generator(this, function (_a) {
                currentUrl = session.get(SESSION_CURRENT_URL_KEY);
                if (currentUrl !== window.location.href) {
                    session.set(SESSION_CURRENT_URL_KEY, window.location.href);
                    this.trackPageHit();
                }
                return [2 /*return*/];
            });
        });
    };
    FormoAnalytics.prototype.trackPageHit = function (category, name, properties, context, callback) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (!this.config.trackLocalhost && isLocalhost()) {
                    return [2 /*return*/, logger.warn("Track page hit: Ignoring event because website is running locally")];
                }
                setTimeout(function () { return __awaiter(_this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        this.trackEvent(EventType.PAGE, {
                            category: category,
                            name: name,
                        }, properties, context, callback);
                        return [2 /*return*/];
                    });
                }); }, 300);
                return [2 /*return*/];
            });
        });
    };
    FormoAnalytics.prototype.trackEvent = function (type, payload, properties, context, callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    this.eventManager.addEvent(__assign(__assign({ type: type }, payload), { properties: properties, context: context, callback: callback }), this.currentAddress, this.currentUserId);
                }
                catch (error) {
                    logger.error("Error tracking event:", error);
                }
                return [2 /*return*/];
            });
        });
    };
    /*
      Utility functions
    */
    FormoAnalytics.prototype.getProviders = function () {
        return __awaiter(this, void 0, void 0, function () {
            var store, providers;
            return __generator(this, function (_a) {
                store = createStore();
                providers = store.getProviders();
                // TODO: consider using store.subscribe to detect changes to providers list
                store.subscribe(function (providerDetails) { return (providers = providerDetails); });
                // Fallback to injected provider if no providers are found
                if (providers.length === 0) {
                    return [2 /*return*/, (window === null || window === void 0 ? void 0 : window.ethereum) ? [window.ethereum] : []];
                }
                return [2 /*return*/, providers];
            });
        });
    };
    FormoAnalytics.prototype.detectWallets = function (providers) {
        return __awaiter(this, void 0, void 0, function () {
            var _i, providers_1, eip6963ProviderDetail, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 5, , 6]);
                        _i = 0, providers_1 = providers;
                        _a.label = 1;
                    case 1:
                        if (!(_i < providers_1.length)) return [3 /*break*/, 4];
                        eip6963ProviderDetail = providers_1[_i];
                        return [4 /*yield*/, this.detect({
                                providerName: eip6963ProviderDetail === null || eip6963ProviderDetail === void 0 ? void 0 : eip6963ProviderDetail.info.name,
                                rdns: eip6963ProviderDetail === null || eip6963ProviderDetail === void 0 ? void 0 : eip6963ProviderDetail.info.rdns,
                            })];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        err_1 = _a.sent();
                        logger.error("Error detect all wallets:", err_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(FormoAnalytics.prototype, "provider", {
        get: function () {
            return this._provider;
        },
        enumerable: false,
        configurable: true
    });
    FormoAnalytics.prototype.getAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var accounts, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.currentAddress)
                            return [2 /*return*/, this.currentAddress];
                        if (!(this === null || this === void 0 ? void 0 : this.provider)) {
                            logger.info("The provider is not set");
                            return [2 /*return*/, null];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.getAccounts()];
                    case 2:
                        accounts = _a.sent();
                        if (accounts && accounts.length > 0) {
                            if (isAddress(accounts[0])) {
                                return [2 /*return*/, accounts[0]];
                            }
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        logger.error("Failed to fetch accounts from provider:", err_2);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    FormoAnalytics.prototype.getAccounts = function (provider) {
        return __awaiter(this, void 0, void 0, function () {
            var p, res, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        p = provider || this.provider;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (p === null || p === void 0 ? void 0 : p.request({
                                method: "eth_accounts",
                            }))];
                    case 2:
                        res = _a.sent();
                        if (!res || res.length === 0)
                            return [2 /*return*/, null];
                        return [2 /*return*/, res.filter(function (e) { return isAddress(e); })];
                    case 3:
                        err_3 = _a.sent();
                        if (err_3.code !== 4001) {
                            logger.error("FormoAnalytics::getAccounts: eth_accounts threw an error", err_3);
                        }
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FormoAnalytics.prototype.getCurrentChainId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chainIdHex, err_4;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.provider) {
                            logger.error("Provider not set for chain ID");
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, ((_a = this.provider) === null || _a === void 0 ? void 0 : _a.request({
                                method: "eth_chainId",
                            }))];
                    case 2:
                        chainIdHex = _b.sent();
                        if (!chainIdHex) {
                            logger.info("Chain id not found");
                            return [2 /*return*/, 0];
                        }
                        return [2 /*return*/, parseInt(chainIdHex, 16)];
                    case 3:
                        err_4 = _b.sent();
                        logger.error("eth_chainId threw an error:", err_4);
                        return [2 /*return*/, 0];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    FormoAnalytics.prototype.buildSignatureEventPayload = function (method, params, response) {
        var basePayload = {
            chainId: this.currentChainId,
            address: method === "personal_sign"
                ? params[1]
                : params[0],
        };
        if (method === "personal_sign") {
            var message = Buffer.from(params[0].slice(2), "hex").toString("utf8");
            return __assign(__assign(__assign({}, basePayload), { message: message }), (response ? { signatureHash: response } : {}));
        }
        return __assign(__assign(__assign({}, basePayload), { message: params[1] }), (response ? { signatureHash: response } : {}));
    };
    FormoAnalytics.prototype.buildTransactionEventPayload = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, data, from, to, value, _b;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _a = params[0], data = _a.data, from = _a.from, to = _a.to, value = _a.value;
                        _c = {};
                        _b = this.currentChainId;
                        if (_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getCurrentChainId()];
                    case 1:
                        _b = (_d.sent());
                        _d.label = 2;
                    case 2: return [2 /*return*/, (_c.chainId = _b,
                            _c.data = data,
                            _c.address = from,
                            _c.to = to,
                            _c.value = value,
                            _c)];
                }
            });
        });
    };
    return FormoAnalytics;
}());
export { FormoAnalytics };
var FormoAnalyticsSession = /** @class */ (function () {
    function FormoAnalyticsSession() {
    }
    FormoAnalyticsSession.prototype.isWalletDetected = function (rdns) {
        var rdnses = session.get(SESSION_WALLET_DETECTED_KEY) || [];
        return rdnses.includes(rdns);
    };
    FormoAnalyticsSession.prototype.markWalletDetected = function (rdns) {
        var rdnses = session.get(SESSION_WALLET_DETECTED_KEY) || [];
        rdnses.push(rdns);
        session.set(SESSION_WALLET_DETECTED_KEY, rdnses);
    };
    return FormoAnalyticsSession;
}());
//# sourceMappingURL=FormoAnalytics.js.map